import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';
import Input from '../../../components/ui/Input';

const LocationManagementPanel = () => {
  const [activeSubTab, setActiveSubTab] = useState('cities');

  const subTabs = [
    { id: 'cities', label: 'Cities', icon: 'MapPin' },
    { id: 'regions', label: 'Regions', icon: 'Globe' },
    { id: 'coverage', label: 'Coverage Areas', icon: 'Map' }
  ];

  const mockCities = [
    { id: 1, name: 'Mumbai', state: 'Maharashtra', vendors: 145, active: true },
    { id: 2, name: 'Delhi', state: 'Delhi', vendors: 132, active: true },
    { id: 3, name: 'Bangalore', state: 'Karnataka', vendors: 98, active: true },
    { id: 4, name: 'Chennai', state: 'Tamil Nadu', vendors: 87, active: true },
    { id: 5, name: 'Kolkata', state: 'West Bengal', vendors: 76, active: true }
  ];

  const renderSubTabContent = () => {
    switch (activeSubTab) {
      case 'cities':
        return (
          <div className="space-y-6">
            <div className="bg-white rounded-xl shadow-soft p-6">
              <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center mb-6">
                <h3 className="font-heading font-semibold text-lg text-text-primary">
                  Manage Cities
                </h3>
                <Button variant="primary" iconName="Plus" iconSize={16}>
                  Add City
                </Button>
              </div>

              <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-6">
                <Input placeholder="Search cities..." icon="Search" />
                <select className="px-4 py-2 border border-border rounded-lg focus:outline-none focus:ring-2 focus:ring-primary-500">
                  <option>All States</option>
                  <option>Maharashtra</option>
                  <option>Delhi</option>
                  <option>Karnataka</option>
                </select>
                <select className="px-4 py-2 border border-border rounded-lg focus:outline-none focus:ring-2 focus:ring-primary-500">
                  <option>All Status</option>
                  <option>Active</option>
                  <option>Inactive</option>
                </select>
              </div>

              <div className="overflow-x-auto">
                <table className="w-full">
                  <thead className="bg-surface-100">
                    <tr>
                      <th className="px-4 py-3 text-left text-xs font-medium text-text-secondary uppercase">
                        City
                      </th>
                      <th className="px-4 py-3 text-left text-xs font-medium text-text-secondary uppercase">
                        State
                      </th>
                      <th className="px-4 py-3 text-left text-xs font-medium text-text-secondary uppercase">
                        Vendors
                      </th>
                      <th className="px-4 py-3 text-left text-xs font-medium text-text-secondary uppercase">
                        Status
                      </th>
                      <th className="px-4 py-3 text-left text-xs font-medium text-text-secondary uppercase">
                        Actions
                      </th>
                    </tr>
                  </thead>
                  <tbody className="divide-y divide-border">
                    {mockCities.map((city) => (
                      <tr key={city.id} className="hover:bg-surface-50">
                        <td className="px-4 py-3">
                          <div className="flex items-center">
                            <div className="w-8 h-8 bg-primary-100 rounded-lg flex items-center justify-center mr-3">
                              <Icon name="MapPin" size={16} className="text-primary" />
                            </div>
                            <span className="font-medium text-text-primary">{city.name}</span>
                          </div>
                        </td>
                        <td className="px-4 py-3 text-text-secondary">{city.state}</td>
                        <td className="px-4 py-3 text-text-secondary">{city.vendors}</td>
                        <td className="px-4 py-3">
                          <span className={`inline-flex px-2 py-1 text-xs font-medium rounded-full ${
                            city.active ? 'bg-success-100 text-success' : 'bg-gray-100 text-gray-600'
                          }`}>
                            {city.active ? 'Active' : 'Inactive'}
                          </span>
                        </td>
                        <td className="px-4 py-3">
                          <div className="flex items-center space-x-2">
                            <button className="text-primary hover:text-primary-600">
                              <Icon name="Edit" size={16} />
                            </button>
                            <button className="text-red-500 hover:text-red-700">
                              <Icon name="Trash2" size={16} />
                            </button>
                          </div>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        );
      case 'regions':
        return (
          <div className="bg-white rounded-xl shadow-soft p-6">
            <div className="text-center py-12">
              <div className="w-16 h-16 bg-primary-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <Icon name="Globe" size={32} className="text-primary" />
              </div>
              <h3 className="font-heading font-semibold text-xl text-text-primary mb-2">
                Regional Management
              </h3>
              <p className="text-text-secondary mb-6">
                Manage geographic regions and service areas
              </p>
              <Button variant="outline" disabled>
                Configure Regions
              </Button>
            </div>
          </div>
        );
      case 'coverage':
        return (
          <div className="bg-white rounded-xl shadow-soft p-6">
            <div className="text-center py-12">
              <div className="w-16 h-16 bg-primary-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <Icon name="Map" size={32} className="text-primary" />
              </div>
              <h3 className="font-heading font-semibold text-xl text-text-primary mb-2">
                Coverage Areas
              </h3>
              <p className="text-text-secondary mb-6">
                Define vendor service coverage areas
              </p>
              <Button variant="outline" disabled>
                Manage Coverage
              </Button>
            </div>
          </div>
        );
      default:
        return null;
    }
  };

  return (
    <div className="space-y-6">
      <div className="bg-gradient-to-r from-primary to-secondary rounded-xl p-6 text-white">
        <h2 className="font-heading font-bold text-2xl mb-2">
          Location Management
        </h2>
        <p className="text-white/90">
          Manage cities, regions, and coverage areas
        </p>
      </div>

      {/* Sub Navigation */}
      <div className="bg-white rounded-xl shadow-soft p-6">
        <div className="flex flex-wrap gap-2">
          {subTabs.map((tab) => (
            <button
              key={tab.id}
              onClick={() => setActiveSubTab(tab.id)}
              className={`flex items-center space-x-2 px-4 py-2 rounded-lg transition-colors ${
                activeSubTab === tab.id
                  ? 'bg-primary text-white' :'text-text-secondary hover:bg-surface-100'
              }`}
            >
              <Icon name={tab.icon} size={16} />
              <span className="font-medium">{tab.label}</span>
            </button>
          ))}
        </div>
      </div>

      {/* Sub Tab Content */}
      {renderSubTabContent()}
    </div>
  );
};

export default LocationManagementPanel;